import { useEffect, useState } from "react";
import { WaitlistForm } from "./WaitlistForm";
import { StoreButtons } from "./StoreButtons";
import { Reveal, MaskLines, Eyebrow } from "./Reveal";
import { getWaitlistCount } from "@/lib/api";

export const FinalCta = () => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    getWaitlistCount().then(setCount).catch(() => setCount(0));
  }, []);

  return (
    <section id="waitlist" className="relative overflow-hidden py-28 sm:py-40" data-testid="waitlist-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:px-12">
        <div className="min-w-0">
          <Reveal><Eyebrow>Early access</Eyebrow></Reveal>
          <h2 className="mt-6 font-serif text-5xl font-light leading-[1] tracking-tight text-[#2C221E] sm:text-6xl lg:text-7xl">
            <MaskLines inView delay={0} lines={["Begin your", <em key="e" className="italic text-[#9E4429]">first season.</em>]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-[#5C4A42] sm:text-lg">
              Join the waitlist for founding-member access, or grab the app the moment it lands.
            </p>
            <div className="mt-10 space-y-5">
              <WaitlistForm prefix="waitlist" onJoined={(c) => c && setCount(c)} />
              <StoreButtons prefix="cta" />
            </div>
            {count > 0 && (
              <p className="mt-6 text-sm text-[#6B5A52]" data-testid="waitlist-count">
                <span className="font-semibold text-[#9E4429]">{count.toLocaleString()}</span> {count === 1 ? "woman has" : "women have"} already joined
              </p>
            )}
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="relative mx-auto aspect-[3/4] w-full max-w-sm overflow-hidden rounded-b-[999px] rounded-t-[2rem]">
            <img src="/img/portrait.webp" loading="lazy" decoding="async" alt="Woman at peace in warm light" className="h-full w-full object-cover" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
